export default {"src":"/_next/static/media/weth.e90e6d21.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};